import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { mdiArrowLeft } from '@mdi/js'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { UserDB } from '@/enitites/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPrivacy',
  props: {
    loading: { type: Boolean },
    user: null
  },
  emits: ["update:user", "save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:user', value: UserDB): void
  (e: 'save'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  loading?: boolean
  user: UserDB
};





const getUser = computed<UserDB>({
  get: () => props.user,
  set: (value) => emit('update:user', value),
})

return { __sfc: true,props, emit, getUser, mdiArrowLeft, store }
}

})